import styled from '@emotion/styled';

export const Line = styled.div`
  display: flex;
  justify-content: space-between; 
  padding: 10px;

  :hover {
    background-color: rgb(230,230,230);
  }
`

export const Label = styled.div`
  text-align: left;
  color: rgb(120,120,120);
  font-size: 14px;
  font-weight: bold;
`

export const Value = styled.div`
  text-align: right;
`
